<div class="dropdown">
  <button class="btn btn-outline-success btn-round" type="button" (click)="onToggle()">Filter <i class="fa fa-filter"></i>
</button>
<form #filterForm='ngForm' (ngSubmit)='onFilter()'>

  <ul style="margin-top: 10px" class="filterBox filter show"  [class.show]="display" [appDraggable]="true">
    <h3 class="dropdown-header m-0 filter-header">
      <span class="grey darken-2">Filter</span>
      <button data-dismiss="filter" aria-label="Close" (click)="onCloseFilter()"  data-toggle="dropdown" class="notification-tag float-right m-0 close">×</button>
    </h3>

    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="name" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control round" id="name" [(ngModel)]="model.name"  name="name">
        </div>
      </div>
    </li>
    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="typeahead-http" class="col-sm-4 col-form-label" >Country</label>
        <div class="col-sm-8">
          <!--<input type="text" class="form-control round" id="country" [(ngModel)]="model.country"  name="country">-->
          <input id="typeahead-http" type="text"  class="form-control round" name="country" [class.is-invalid]="searchFailed" [(ngModel)]="model.country" [ngbTypeahead]="search" placeholder="Search Country" />
          @if (searching) {
            <span>searching...</span>
          }
          @if (searchFailed) {
            <div class="invalid-feedback">Sorry, suggestions could not be loaded.</div>
          }

        </div>
      </div>
    </li>
    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="state" class="col-sm-4 col-form-label" >State/Province</label>
        <div class="col-sm-8">
          <input type="text" class="form-control round" id="state" name="state"  [class.is-invalid]="searchFailed" [(ngModel)]="model.state" [ngbTypeahead]="searchState" placeholder="Search State" />
          @if (searching) {
            <span>searching...</span>
          }
          @if (searchFailed) {
            <div class="invalid-feedback">Sorry, suggestions could not be loaded.</div>
          }

        </div>
      </div>
    </li>
    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="date" class="col-sm-4 col-form-label" >Date Added</label>
        <div class="col-sm-8">

          <div class="input-group btn-round">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-calendar-o"></i>
              </span>
            </div>
            <input type='text' class="form-control pickadate btn-round" id="date" placeholder="Input Date"
              appDatePicker   [(ngModel)]="model.date"  name="date" />
          </div>
        </div>
      </div>
    </li>
    <li class="dropdown-header m-0">
      <div class="form-group row">
        <label for="status" class="col-sm-4 col-form-label" >Status</label>
        <div class="col-sm-8">
          <ui-switch checked id="status" [(ngModel)]="model.status" name="status"></ui-switch>
        </div>
      </div>
    </li>
    <li class="dropdown-header m-0">
      <div class="form-group row">
        <div class="col-sm-4"></div>
        <div class="col-sm-8 pull-right">

          <button type="submit" class="btn btn-success btn-round pl-30 pr-30 pull-right" [disabled]="filterForm.invalid">Filter</button>
          <button type="reset" (click)='resetFilter()' class="btn reset pl-30 pr-30 pull-right">Reset</button>
        </div>
      </div>
    </li>
  </ul>
</form>
</div>
